module.exports = __webpack_public_path__ + "static/img/LogoACS.c1084c22.png";